import { render } from "./AccountInfo.vue?vue&type=template&id=522824b4&scoped=true"
import script from "./AccountInfo.vue?vue&type=script&lang=js"
export * from "./AccountInfo.vue?vue&type=script&lang=js"

import "./AccountInfo.vue?vue&type=style&index=0&id=522824b4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522824b4"]])

export default __exports__